import { Ear } from "api/memberPortal/ear/ear.types";
import LinkCell from "components/MUI/DataGrid/Cells/Link.cell";
import { useAuth } from "hooks/useAuth";

const EarLinkCell = ({ row }: { row: Ear }) => {
  const { permissions } = useAuth();

  if (
    permissions?.role_type === "Lab" &&
    (row.status === "Draft" || row.status === "Pending Review")
  ) {
    return <>{row.earid}</>;
  }
  return (
    <LinkCell
      to={`/community/ear-reviews/details/${row.earid}`}
      label={row.earid}
    />
  );
};

export default EarLinkCell;
